import React, { FC } from 'react';
import cx from 'classnames';
// internal
import block from './block.json';

/**
 * COMPONENT
 */
export const SectionTwoColumnsCol: FC<ColumnProps> & BlockConfigs = ({
	slug,
	children,
}) => {
	const trimmedSlug = slug.split('-');

	const rootClass = cx(
		'supt-section__col',
		`supt-section__col--${trimmedSlug[trimmedSlug.length - 1]}`
	);

	return <div className={rootClass}>{children}</div>;
};

SectionTwoColumnsCol.slug = block.slug;
SectionTwoColumnsCol.title = block.title;
